/*
 * Trousella — Panier latéral (style ConvertX)
 * Minuteur, mises à jour Ajax sérialisées, rafraîchissement cohérent.
 * Implémentation indépendante, sans dépendance externe.
 */
(function () {
  'use strict';

  var TIMER_KEY = 'trousella-cxd-timer-end';
  var MAX_AGE = 24 * 60 * 60 * 1000;
  var memoryEnd = null;

  /* ---------- Stockage du minuteur ---------- */
  function readEnd() {
    try {
      var v = parseInt(window.localStorage.getItem(TIMER_KEY), 10);
      return isNaN(v) ? null : v;
    } catch (e) {
      return memoryEnd;
    }
  }

  function writeEnd(v) {
    memoryEnd = v;
    try {
      if (v === null) window.localStorage.removeItem(TIMER_KEY);
      else window.localStorage.setItem(TIMER_KEY, String(v));
    } catch (e) {}
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function format(seconds) {
    var s = Math.max(0, Math.ceil(seconds));
    return pad(Math.floor(s / 60)) + ':' + pad(s % 60);
  }

  /* ---------- Minuteur ---------- */
  if (!customElements.get('cxd-timer')) {
    customElements.define(
      'cxd-timer',
      class CxdTimer extends HTMLElement {
        connectedCallback() {
          this.duration = parseInt(this.dataset.duration, 10) || 0;
          this.mode = this.dataset.mode || 'fixed';
          this.onExpire = this.dataset.expire || 'message';
          this.template = this.dataset.text || '';
          this.expiredText = this.dataset.expiredText || '';
          this.textEl = this.querySelector('[data-cxd-timer-text]');

          if (this.duration <= 0 || !this.textEl) {
            this.hidden = true;
            return;
          }

          var end = readEnd();
          var now = Date.now();
          if (!end || end < now - MAX_AGE) {
            end = now + this.duration * 1000;
            writeEnd(end);
          }

          this.buildText();
          this.classList.add('is-ready');
          this.tick();
          this.interval = window.setInterval(this.tick.bind(this), 1000);
        }

        disconnectedCallback() {
          if (this.interval) window.clearInterval(this.interval);
        }

        restart() {
          writeEnd(Date.now() + this.duration * 1000);
          this.hidden = false;
          this.buildText();
          this.tick();
        }

        buildText() {
          var token = '{' + '{timer}' + '}';
          var parts = this.template.split(token);
          this.textEl.textContent = '';
          this.timeEls = [];
          for (var i = 0; i < parts.length; i++) {
            if (parts[i]) this.textEl.appendChild(document.createTextNode(parts[i]));
            if (i < parts.length - 1) {
              var strong = document.createElement('strong');
              this.textEl.appendChild(strong);
              this.timeEls.push(strong);
            }
          }
          this.expiredShown = false;
        }

        tick() {
          var end = readEnd();
          if (!end) return;
          var remaining = (end - Date.now()) / 1000;

          if (remaining <= 0) {
            if (this.onExpire === 'restart') {
              this.restart();
              return;
            }
            if (this.onExpire === 'hide' || !this.expiredText) {
              this.hidden = true;
              return;
            }
            if (!this.expiredShown) {
              this.textEl.textContent = this.expiredText;
              this.timeEls = [];
              this.expiredShown = true;
            }
            return;
          }

          var label = format(remaining);
          for (var i = 0; i < this.timeEls.length; i++) {
            if (this.timeEls[i].textContent !== label) this.timeEls[i].textContent = label;
          }
        }
      }
    );
  }

  /* ---------- Utilitaires panier ---------- */
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function parseSection(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function fixPaymentGradients(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cxd-payments]').forEach(function (list) {
      list.querySelectorAll('linearGradient, radialGradient').forEach(function (g) {
        if (!g.id || g.id.indexOf('-cxd') !== -1) return;
        var oldId = g.id;
        var newId = oldId + '-cxd';
        g.id = newId;
        var svg = g.closest('svg');
        if (!svg) return;
        svg.querySelectorAll('[fill="url(#' + oldId + ')"]').forEach(function (el) {
          el.setAttribute('fill', 'url(#' + newId + ')');
        });
        svg.querySelectorAll('[stroke="url(#' + oldId + ')"]').forEach(function (el) {
          el.setAttribute('stroke', 'url(#' + newId + ')');
        });
      });
    });
  }

  function renderSections(sections, itemCount) {
    var drawer = getDrawer();
    if (sections && sections['cart-drawer']) {
      var src = parseSection(sections['cart-drawer'], '.drawer__inner');
      var dst = document.querySelector('#CartDrawer .drawer__inner');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
    if (sections && sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var srcBubble = parseSection(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && srcBubble) bubble.innerHTML = srcBubble.innerHTML;
    }
    if (drawer && typeof itemCount === 'number') {
      drawer.classList.toggle('is-empty', itemCount === 0);
      if (itemCount === 0) writeEnd(null);
    }
    fixPaymentGradients(drawer);
  }

  function refreshDrawer() {
    var url = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var src = parseSection(sections['cart-drawer'], '.drawer__inner');
        var count = src ? src.querySelectorAll('.cxd-item').length : undefined;
        renderSections(sections, count);
      })
      .catch(function () {});
  }

  function findLineByKey(key) {
    var el = document.querySelector('#CartDrawer .cxd-item[data-key="' + CSS.escape(key) + '"]');
    return el ? el.dataset.index : null;
  }

  function showLineError(key, message) {
    var line = key ? findLineByKey(key) : null;
    var target = line ? document.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text') : null;
    if (target) {
      target.textContent = message;
    } else {
      var global = document.getElementById('CartDrawer-CartErrors');
      if (global) global.textContent = message;
    }
  }

  function announce(message) {
    var live = document.getElementById('CartDrawer-LiveRegionText');
    if (live) live.textContent = message;
  }

  function restoreFocus(key) {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('active') || typeof trapFocus !== 'function') return;
    var line = key ? findLineByKey(key) : null;
    var el = line ? document.getElementById('Drawer-quantity-' + line) : null;
    if (drawer.classList.contains('is-empty')) {
      var empty = drawer.querySelector('.drawer__inner-empty');
      if (empty) trapFocus(empty, empty.querySelector('a, button'));
      return;
    }
    trapFocus(drawer, el || drawer.querySelector('.cxd__close'));
  }

  function errorText() {
    return (window.cartStrings && window.cartStrings.error) || 'Une erreur est survenue. Veuillez réessayer.';
  }

  /* ---------- Mise à jour sérialisée (évite les réponses dans le désordre) ---------- */
  var queue = Promise.resolve();

  function changeLine(line, quantity) {
    var item = document.getElementById('CartDrawer-Item-' + line);
    var key = item ? item.dataset.key : null;
    if (!key) return Promise.resolve();

    var qty = Math.max(0, parseInt(quantity, 10) || 0);
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('cxd--loading');
    var errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = '';

    var config = typeof fetchConfig === 'function'
      ? fetchConfig()
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    config.body = JSON.stringify({
      id: key,
      quantity: qty,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    return fetch(window.routes.cart_change_url, config)
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status || data.errors) {
          var message = data.description || data.message || errorText();
          return refreshDrawer().then(function () {
            showLineError(key, message);
          });
        }

        renderSections(data.sections, data.item_count);
        announce('Panier mis à jour');

        if (qty > 0 && Array.isArray(data.items)) {
          var updated = data.items.find(function (i) {
            return i.key === key;
          });
          if (updated && updated.quantity < qty && window.cartStrings && window.cartStrings.quantityError) {
            showLineError(key, window.cartStrings.quantityError.replace('[quantity]', updated.quantity));
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
        }
        restoreFocus(key);
      })
      .catch(function () {
        return refreshDrawer().then(function () {
          var global = document.getElementById('CartDrawer-CartErrors');
          if (global) global.textContent = errorText();
        });
      })
      .finally(function () {
        if (drawer) drawer.classList.remove('cxd--loading');
      });
  }

  var refreshTimeout = null;
  function scheduleRefresh() {
    window.clearTimeout(refreshTimeout);
    refreshTimeout = window.setTimeout(function () {
      queue = queue.then(refreshDrawer);
    }, 250);
  }

  customElements.whenDefined('cart-drawer-items').then(function () {
    var CartDrawerItemsClass = customElements.get('cart-drawer-items');
    if (!CartDrawerItemsClass || CartDrawerItemsClass.prototype.__cxdPatched) return;
    CartDrawerItemsClass.prototype.__cxdPatched = true;

    CartDrawerItemsClass.prototype.updateQuantity = function (line, quantity) {
      queue = queue.then(function () {
        return changeLine(line, quantity);
      });
      return queue;
    };

    // Mise à jour externe du panier (ajout, quick add…) : on recharge le tiroir lui-même.
    CartDrawerItemsClass.prototype.onCartUpdate = function () {
      scheduleRefresh();
    };
  });

  /* ---------- Ouverture / redémarrage du minuteur ---------- */
  function watchDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.__cxdWatched) return;
    drawer.__cxdWatched = true;

    if (drawer.classList.contains('is-empty')) writeEnd(null);

    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var active = drawer.classList.contains('active');
      if (active && !wasActive) {
        var timer = drawer.querySelector('cxd-timer');
        if (timer && timer.mode === 'restart' && typeof timer.restart === 'function') timer.restart();
      }
      wasActive = active;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:select', function (event) {
    if (event.detail && event.detail.sectionId === 'cart-drawer') {
      var drawer = getDrawer();
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.detail && event.detail.sectionId === 'cart-drawer') {
      var drawer = getDrawer();
      if (drawer && typeof drawer.close === 'function') drawer.close();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    watchDrawer();
    fixPaymentGradients();
  });

  watchDrawer();
  fixPaymentGradients();
})();
